import { Outlet, createFileRoute } from '@tanstack/react-router';

/** Layout for `/profile/messages` and `/profile/messages/$messageId`. */
export const Route = createFileRoute('/profile/messages')({
  component: ProfileMessagesLayout,
});

function ProfileMessagesLayout() {
  return <Outlet />;
}
